@for (entity of this.link().children; track entity) {
  <cam-link (action)="this.goTo()">
    @switch (entity.type) {
      @case ('text') {
        <cam-rich-paragraph-text [text]="$any(entity)"></cam-rich-paragraph-text>
      }
    }
  </cam-link>
}
